var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicensePlateMegatron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#FFDFEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.25C13.5858 19.25 13.25 19.5858 13.25 20C13.25 20.4142 13.5858 20.75 14 20.75V19.25ZM16.6667 20.75C17.0809 20.75 17.4167 20.4142 17.4167 20C17.4167 19.5858 17.0809 19.25 16.6667 19.25V20.75ZM19.3333 19.25C18.9191 19.25 18.5833 19.5858 18.5833 20C18.5833 20.4142 18.9191 20.75 19.3333 20.75V19.25ZM22 20.75C22.4142 20.75 22.75 20.4142 22.75 20C22.75 19.5858 22.4142 19.25 22 19.25V20.75ZM13.3333 14.75H22.6667V13.25H13.3333V14.75ZM23.25 15.3333V20.6667H24.75V15.3333H23.25ZM12.75 20.6667V15.3333H11.25V20.6667H12.75ZM13.3333 21.25C13.0112 21.25 12.75 20.9888 12.75 20.6667H11.25C11.25 21.8173 12.1827 22.75 13.3333 22.75V21.25ZM23.25 20.6667C23.25 20.9888 22.9888 21.25 22.6667 21.25V22.75C23.8173 22.75 24.75 21.8173 24.75 20.6667H23.25ZM22.6667 14.75C22.9888 14.75 23.25 15.0112 23.25 15.3333H24.75C24.75 14.1827 23.8173 13.25 22.6667 13.25V14.75ZM13.3333 13.25C12.1827 13.25 11.25 14.1827 11.25 15.3333H12.75C12.75 15.0112 13.0112 14.75 13.3333 14.75V13.25ZM12 17.4167H18V15.9167H12V17.4167ZM18 17.4167H24V15.9167H18V17.4167ZM22.6667 21.25H18V22.75H22.6667V21.25ZM18 21.25H13.3333V22.75H18V21.25ZM14 20.75H16.6667V19.25H14V20.75ZM19.3333 20.75H22V19.25H19.3333V20.75Z",
    fill: "#A3006C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensePlateMegatron);
export default __webpack_public_path__ + "static/media/LicensePlateMegatron.eb25cb45e584c3fc538db2174a2ee57c.svg";
export { ForwardRef as ReactComponent };